import { render, staticRenderFns } from "./CardCommentForm.vue?vue&type=template&id=6fa4bab2&"
import script from "./CardCommentForm.vue?vue&type=script&lang=js&"
export * from "./CardCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports